import * as React from 'react'
import update from 'immutability-helper'

import Card from './Card'
import { Creative, CreativeAction } from '../../../interfaces/entities/creative'

import DI from '../../../app/di'
import { ICreativeService } from '../../../interfaces/services/creatives'
import { SelectableCreativeCard } from '../../../interfaces/entities/cards'
import { MakeCreativeCard } from '../CreativeCard'

export type Props = {
  creatives: Creative[]
  recommendedNoOfCreatives: number
  doCreativeAction?: (creative: Creative, action: CreativeAction) => any
  formatSetType: string
}

export interface State {
  cards: Array<{
    id: string
  }>
}

export default function Container(props: Props) {
  const [state, setState] = React.useState<State>({
    cards: props.creatives.map((creative) => {
      return { id: creative.id }
    }),
  })

  React.useEffect(() => {
    setState((state) => ({
      ...state,
      cards: props.creatives.map((creative) => {
        return { id: creative.id }
      }),
    }))
  }, [props.creatives])

  const findCard = (id: string) => {
    const { cards } = state
    const card = cards.find((c) => `${c.id}` === id) || null
    const index = cards.findIndex((c) => `${c.id}` === id)

    return {
      card,
      index,
    }
  }

  const moveCard = (
    cardId: string,
    atIndex: number,
    saveToServer: boolean = false,
  ) => {
    const { card, index } = findCard(cardId)

    if (!card) {
      return
    }

    const creativeService = DI.get('CreativeService') as ICreativeService

    const id = card.id
    const displayOrder = index + 1

    if (saveToServer) {
      creativeService.updateCardPosition(id, displayOrder)
    }

    setState(
      update(state, {
        cards: {
          $splice: [
            [index, 1],
            [atIndex, 0, card],
          ],
        },
      }),
    )
  }

  const { cards } = state

  return (
    <>
      {cards.map((card, i) => {
        const creative = props.creatives.find((c) => c.id === card.id)

        if (creative) {
          const creativeCard: SelectableCreativeCard = {
            card: MakeCreativeCard(creative),
            status:
              i >= props.recommendedNoOfCreatives ? 'over_recommended' : null,
          }

          return (
            <Card
              key={card.id}
              index={i}
              id={card.id}
              creativeCard={creativeCard}
              moveCard={moveCard}
              doCreativeAction={props.doCreativeAction}
              formatSetType={props.formatSetType}
            />
          )
        }

        return null
      })}
    </>
  )
}
